import { parseCookies } from '@cian/utils/lib/shared/cookie';

export default [
  function () {
    // Cookies
    const cookies = parseCookies(document.cookie);
    const isMobileCookie = !cookies.fpAdaptiveMode || cookies.fpAdaptiveMode === 'mobile';

    const deviceType = window.addformDeviceType || 'desktop';
    const deviceOperatingSystem = window.deviceOperatingSystem;

    const isMobileDeviceType = deviceType === 'phone' || deviceType === 'tablet';
    const isMobile = isMobileDeviceType && isMobileCookie;

    const svc = {
      deviceOperatingSystem,
      isMobile,
    };

    window.adaptiveFlags = {
      isMobile,
      deviceOperatingSystem,
    };

    return svc;
  },
];
